import React, { useState, useEffect ,useRef} from "react";
import { Modal } from "react-bootstrap";
import "../../style/UserCreateForm.css";
import { Alert } from "react-bootstrap";
import { BASE_URL } from "../../utils/config";
import Sidebar from '../../components/sidebar';
import { useNavigate } from 'react-router-dom';
import { Toast } from "primereact/toast";
import Container from 'react-bootstrap/Container';
import TelegramWidget from "../../components/widget/telegramWidget";

const UserCreateForm = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",    
    email_address: "",
    phone_number: "",   
    status: "",
    password: "",
    confirm_password: "",
    RoleType:"",
    renko_access:"",
    automate_renko_access:""

  });
  // Define state variables for the success alerts
  const toast = useRef(null);
  const [showInvalidEmailAlert, setShowInvalidEmailAlert] = useState(false);
  const [showInvalidPhoneAlert, setShowInvalidPhoneAlert] = useState(false);
  const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] = useState(false);
  const [showInvalidNameAlert, setShowInvalidNameAlert] = useState(false);
  const [showInvalidMatchPasswordAlert, setShowInvalidMatchPasswordAlert] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showEmptyAlert, setshowEmptyAlert] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%#&*])[A-Za-z\d@$!%*#&]{8,16}$/;
  let NameRegex = /^[a-zA-Z]+( [a-zA-Z]+)?$/;
  const phoneRegex = /^\d{10}$/;
  const navigate = useNavigate();

  //  this function is used to handle changes of input fileds
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

//  this function is used to submit the form
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    try {
      if (
        formData.first_name === "" ||
        formData.last_name === "" || 
        formData.email_address === "" ||
        formData.phone_number === "" ||
        formData.password === "" ||
        formData.confirm_password === "" ||    
        formData.status ===""||
        formData.RoleType === ""||
        formData.renko_access === ""||
        formData.automate_renko_access === ""
    
      ) {
        setshowEmptyAlert(true);
        setTimeout(() => {
          setshowEmptyAlert(false);
        }, 2000);
      } else if (!emailRegex.test(formData.email_address)) {
        setShowInvalidEmailAlert(true);
        setTimeout(() => {
          setShowInvalidEmailAlert(false);
        }, 2000);
      } else if (!phoneRegex.test(formData.phone_number)) {
        setShowInvalidPhoneAlert(true);
        setTimeout(() => {
          setShowInvalidPhoneAlert(false);
        }, 2000);
      } else if (!passwordRegex.test(formData.confirm_password)) {
        setShowInvalidPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidPasswordAlert(false);
        }, 2000);
      } else if (!NameRegex.test(formData.first_name)) {
        setShowInvalidNameAlert(true);
        setTimeout(() => {
          setShowInvalidNameAlert(false);
        }, 2000);
      } else if (formData.middle_name !== "" && !NameRegex.test(formData.middle_name)) {
        console.log("formData.middle_name",formData.middle_name)
      
            setShowInvalidNameAlert(true);
            setTimeout(() => {
              setShowInvalidNameAlert(false);
            }, 2000);
      } else if (!NameRegex.test(formData.last_name)) {
        setShowInvalidNameAlert(true);
        setTimeout(() => {
          setShowInvalidNameAlert(false);
        }, 2000);
      } else if (!passwordRegex.test(formData.confirm_password)) {
        setShowInvalidPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidPasswordAlert(false);
        }, 2000);
      } else if (formData.password !== formData.confirm_password) {
        console.log("password and confirm password doesn't match");
        setShowInvalidMatchPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidPasswordAlert(false);
        }, 2000);
      }
      else {
        let loginuser = JSON.parse(localStorage.getItem('loginData'));
        let body = JSON.stringify({ userdetails: formData,created_by:loginuser.user_id});
        fetch(`${BASE_URL}/createuser`, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${loginuser.token}`
          },
        })
          .then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            
            if(res.success === true){
              setShowSuccessMessage(true); 
             
              setTimeout(() => {
                  setShowSuccessMessage(false);
                  navigate('/userlist');
                }, 2000);
             
            }else if(res.status === 403){ 
              
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); // Show an error message here, if applicable
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage('')
                localStorage.clear()
                navigate('/login')
                // Additional logic for handling the "else" condition
              }, 3000);

            }
            else if(res.status === 401){
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); // Show an error message here, if applicable
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage('')
                localStorage.clear()
                navigate('/login')
                // Additional logic for handling the "else" condition
              }, 3000);
            }else{
              setErrorMessage(`Error: ${res.message}`)
              setShowErrorMessage(true); // Show an error message here, if applicable
              setTimeout(() => {
                setShowErrorMessage(false);
                setErrorMessage('')
                // Additional logic for handling the "else" condition
              }, 3000);

             
            }
           
          }).catch(error=>{
            setErrorMessage(`Error: ${error.message}`)
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false)
        setErrorMessage('')
      }, 2000);
          })
      }
    } catch(error) { 
      setErrorMessage(`Error: ${error.message}`)
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false)
        setErrorMessage('')
      }, 2000);
    }
  };


  return (
    <div>
     
      <Sidebar />
      <div className="add-user" style={{marginTop:"100px"}}>
      <Toast ref={toast} position="top-center" />
        <Container>
          <h1>Add User</h1>
          <form onSubmit={handleSubmit}>
            <div className="general-information">
              <h6>General Information</h6>
              <div className="row">
                {showEmptyAlert && (
                  <Alert
                    variant="danger"
                    onClose={() => setshowEmptyAlert(false)}
                    dismissible
                  >
                    Fields cannot be empty.
                  </Alert>
                )}              
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="first_name" style={{color:"#000", fontWeight:"bold"}}>
                      First Name<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      placeholder="Enter your first name"
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="middle_name"  style={{color:"#000", fontWeight:"bold"}}>Middle Name</label>
                    <input
                      type="text"
                      id="middle_name"
                      name="middle_name"
                      placeholder="Enter your middle name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label for="last_name"  style={{color:"#000", fontWeight:"bold"}}>
                      Last Name<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Enter your last name"
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="email"  style={{color:"#000", fontWeight:"bold"}}>
                      E-mail<span className="astrik-mark">*</span>
                    </label>
                    <input
                      // type="text"
                      type="email"
                      id="email_address"
                      name="email_address"
                      placeholder="Enter your e-mail address"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="phone_number"  style={{color:"#000", fontWeight:"bold"}}>
                      Phone Number<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="number"
                      id="phone_number"
                      name="phone_number"
                      placeholder="Enter your phone number"
                      maxLength={10}
                      onChange={handleChange}
                      required
                     
                    />
                  </div>
                </div>
              </div>
            </div>
           
           
            <div className="account-maintenance" style={{marginTop:"30px"}}>
              <h6>Account Maintenance</h6>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="status"  style={{color:"#000", fontWeight:"bold"}}
                    >Role Type<span className="astrik-mark">*</span></label>
                    <select
                      id="RoleType"
                      name="RoleType"
                      value={formData.RoleType}
                      onChange={handleChange}
                    >
                      <option value="">Select User Role</option>
                      <option value="SuperAdmin">Super Admin</option>
                      <option value="Supervisor">Supervisor</option>
                      <option value="User">User</option>
                      <option value="MCXUser">MCX User</option>
                    </select>
                  </div>

                  </div>
                  <div className="col-sm-6">
                  <div className="form-group">
                    <label for="status"  style={{color:"#000", fontWeight:"bold"}}
                    >Status<span className="astrik-mark">*</span></label>
                    <select
                      id="status"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  </div>

                  <div className="col-sm-6">
                  <div className="form-group">
                    <label for="renko_access"  style={{color:"#000", fontWeight:"bold"}}
                    >Renko Access<span className="astrik-mark">*</span></label>
                    <select
                      id="renko_access"
                      name="renko_access"
                      value={formData.renko_access}
                      onChange={handleChange}
                    >
                      <option value="">Select Renko Access Permission</option>
                      <option value="1">Yes</option>
                      <option value="0">NO</option>
                    </select>
                  </div>
                  </div>
                  <div className="col-sm-6">
                  <div className="form-group">
                    <label for="automate_renko_access"  style={{color:"#000", fontWeight:"bold"}}
                    >Automate Renko Access<span className="astrik-mark">*</span></label>
                    <select
                      id="automate_renko_access"
                      name="automate_renko_access"
                      value={formData.automate_renko_access}
                      onChange={handleChange}
                    >
                      <option value="">Select Automate Renko Access Permission</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                  </div>

                  <div className="col-sm-6">
                  <div className="form-group">
                    <label for="password"  style={{color:"#000", fontWeight:"bold"}}>
                    
                      Password<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className="col-sm-6">
                  <div className="form-group">
                    <label for="confirm_password"  style={{color:"#000", fontWeight:"bold"}}>
                      Confirm Password<span className="astrik-mark">*</span>
                    </label>
                    <input
                      type="password"
                      id="confirm_password"
                      name="confirm_password"
                      placeholder="Enter your confirm password"
                      onChange={handleChange}
                    />
                  </div>
                  
                </div>
                
              </div>
              <TelegramWidget/>
            </div>
          


            {/* Success Alert */}
            <Modal show={showSuccessMessage} onHide={() => setShowSuccessMessage(false)} style={{ padding: 0 }}> <Alert variant="success">
              " User create form has been saved successfully."
            </Alert>
            </Modal>

            {/* failed Alert */}
            <Modal show={showErrorMessage} onHide={() => setShowErrorMessage(false)} style={{ padding: 0 }}> <Alert variant="danger">
              {errorMessage}
            </Alert>
            </Modal>

            {/* Email Alert */}
            <Modal show={showInvalidEmailAlert} onHide={() => setShowInvalidEmailAlert(false)}  > <Alert variant="danger" style={{ margin: 0 }}>
              "  Please enter a valid email address. Make sure to include
              "@" and use a proper domain (e.g., example.com)."
            </Alert>
            </Modal>
            
            <Modal show={showInvalidPasswordAlert} onHide={() => setShowInvalidPasswordAlert(false)} style={{ paddingTop: '0', paddingBottom: '0' }}>
  <Alert variant="danger">
    Please enter a valid password with the following criteria:
    <ul>
      <li>At least 8 characters.</li>
      <li>At least one capital letter (A).</li>
      <li>At least one small letter (a).</li>
      <li>At least one special character (@).</li>
      <li>At least one number (123).</li>
    </ul>
  </Alert>
</Modal>
            {/* Name Alert */}
            <Modal show={showInvalidNameAlert} onHide={() => setShowInvalidNameAlert(false)} style={{ paddingTop: '0', paddingBottom: '0' }}> <Alert variant="danger">
              " In First name, middle name and last name accept only characters."
            </Alert>
            </Modal>

            {/* Password not match Alert */}
            <Modal show={showInvalidMatchPasswordAlert} onHide={() => setShowInvalidMatchPasswordAlert(false)} > <Alert variant="danger">
              "  Password and confirm password do not match. Please make
              sure they are the same."
            </Alert>
            </Modal>

            {/* Phone no Alert */}
            <Modal show={showInvalidPhoneAlert} onHide={() => setShowInvalidPhoneAlert(false)} > <Alert variant="danger">
              " Please enter a valid phone number. Phone numbers should consist
              of 10 digits and can include optional dashes or spaces (e.g., 123-456-7890 or 1234567890)."
            </Alert>
            </Modal>


            {/* Empty Alert */}
            <Modal show={showEmptyAlert} onHide={() => setshowEmptyAlert(false)} > <Alert variant="danger">
              " Please fill in all required fields. Fields cannot be empty."
            </Alert>
            </Modal>
            <div style={{ display: "flex", justifyContent: "center" , marginTop:"50px"}}>
            <button className="btn-submit" type="submit">
              Submit
            </button>
            </div>
          </form>
        </Container>
      </div>
    </div>
  );
};

export default UserCreateForm;
